<!-- Bezel mask: blacks out corners *outside* the rounded window -->
<div class="bezel" aria-hidden="true"></div>

<!-- Safe-Area Debug (SAD) bars -->
<div class="sad sad-top"    [style.height.px]="top()"></div>
<div class="sad sad-right"  [style.width.px]="right()"></div>
<div class="sad sad-bottom" [style.height.px]="bottom()"></div>
<div class="sad sad-left"   [style.width.px]="left()"></div>

<!-- Notch -->
<div class="notch" [class.notch--hidden]="top() === 0"></div>

<!-- HUD -->
<div class="sad-hud"></div>
<div class="safe-line-top"></div>
<div class="safe-line-bottom"></div>
